<template>
  <oxd-form-row>
    <oxd-input-field
      :model-value="modelValue"
      type="select"
      label="Lien de parenté"
      :options="relationships"
      :rules="rules"
      required
      @update:model-value="$emit('update:modelValue', $event)"
    />
    <oxd-text
      v-if="modelValue?.id === 'other'"
      tag="p"
      class="orangehrm-input-hint"
    >
      Pour le lien de parenté « Autre », la demande sera enregistrée comme «
      Absence non rémunérée ». Un commentaire est requis ; le justificatif reste
      facultatif.
    </oxd-text>
  </oxd-form-row>
</template>

<script>
import {FAMILY_RELATIONSHIPS} from '@/orangehrmLeavePlugin/util/leave-type-policy';
export default {
  props: {modelValue: {type: Object, default: null}},
  emits: ['update:modelValue'],
  data() {
    return {
      relationships: FAMILY_RELATIONSHIPS,
      rules: [
        (value) => !!value || 'Veuillez sélectionner le lien de parenté.',
      ],
    };
  },
};
</script>
